import React from 'react';
import GsbAll, {
   ReactComponent as IconGsbAll,
} from '../../assets/svg/gsb-iconAll.svg';
import GsbBeauty, {
   ReactComponent as IconsGsbBeauty,
} from '../../assets/svg/gsb-iconBeauty&Health.svg';
import GsbEntertain, {
   ReactComponent as IconsGsbEntertain,
} from '../../assets/svg/gsb-iconEntertainment.svg';
import GsbFood, {
   ReactComponent as IconsGsbFood,
} from '../../assets/svg/gsb-iconFood-&-Beverage.svg';
import GsbFree, {
   ReactComponent as IconsGsbFree,
} from '../../assets/svg/gsb-iconFree.svg';
import GsbHotel, {
   ReactComponent as IconsGsbHotel,
} from '../../assets/svg/gsb-iconHotel&Travel.svg';
import GsbHouseWare, {
   ReactComponent as IconsGsbHouseWare,
} from '../../assets/svg/gsb-iconHousewares&Electronic.svg';
import GsbLimited, {
   ReactComponent as IconsGsbLimited,
} from '../../assets/svg/gsb-iconLimited-Edition.svg';
import GsbNewArrival, {
   ReactComponent as IconsGsbNewArrival,
} from '../../assets/svg/gsb-iconNew-Arrival.svg';
import GsbBank, {
   ReactComponent as IconsGsbBank,
} from '../../assets/svg/gsb-iconNew-Arrival-copy.svg';
import GsbService, {
   ReactComponent as IconsGsbService,
} from '../../assets/svg/gsb-iconService.svg';
import GsbSport, {
   ReactComponent as IconsGsbSport,
} from '../../assets/svg/gsb-iconSport&Activities.svg';
import Gsburvey, {
   ReactComponent as IconsGsbSurvey,
} from '../../assets/svg/gsb-iconSurvey.svg';

export function getCatIconsForCss(type) {
   if (type === 0) return GsbAll;
   else if (type === 1) return GsbBeauty;
   else if (type === 2) return GsbEntertain;
   else if (type === 3) return GsbFood;
   else if (type === 4) return GsbFree;
   else if (type === 5) return GsbHotel;
   else if (type === 6) return GsbHouseWare;
   else if (type === 7) return GsbLimited;
   else if (type === 8) return GsbNewArrival;
   else if (type === 9) return GsbBank;
   else if (type === 10) return GsbService;
   else if (type === 11) return GsbSport;
   else if (type === 12) return Gsburvey;
   else return false;
}

export function getCatIcons(type) {
   if (type === 0) return <IconGsbAll className={'myCustom-svg'} />;
   else if (type === 1) return <IconsGsbBeauty className={'myCustom-svg'} />;
   else if (type === 2) return <IconsGsbEntertain className={'myCustom-svg'} />;
   else if (type === 3) return <IconsGsbFood className={'myCustom-svg'} />;
   else if (type === 4) return <IconsGsbFree className={'myCustom-svg'} />;
   else if (type === 5) return <IconsGsbHotel className={'myCustom-svg'} />;
   else if (type === 6) return <IconsGsbHouseWare className={'myCustom-svg'} />;
   else if (type === 7) return <IconsGsbLimited className={'myCustom-svg'} />;
   else if (type === 8)
      return <IconsGsbNewArrival className={'myCustom-svg'} />;
   else if (type === 9) return <IconsGsbBank className={'myCustom-svg'} />;
   else if (type === 10) return <IconsGsbService className={'myCustom-svg'} />;
   else if (type === 11) return <IconsGsbSport className={'myCustom-svg'} />;
   else if (type === 12) return <IconsGsbSurvey className={'myCustom-svg'} />;
   else return false;
}

export function reverseFormatNumber(val, locale) {
   var group = new Intl.NumberFormat(locale).format(1111).replace(/1/g, '');
   var decimal = new Intl.NumberFormat(locale).format(1.1).replace(/1/g, '');
   var reversedVal = val.replace(new RegExp('\\' + group, 'g'), '');
   reversedVal = reversedVal.replace(new RegExp('\\' + decimal, 'g'), '.');
   return Number.isNaN(reversedVal) ? 0 : reversedVal;
}

export function isObject(value) {
   return value && typeof value === 'object' && value.constructor === Object;
}

export const checkStatusSelect = (data) => {
   const options = [
      { value: 1, label: 'Active', color: '#4ba23a' },
      { value: 2, label: 'Inactive', color: '#9e9e9e' },
      { value: 3, label: 'Expire', color: '#da3a3c' },
   ];
   if (data === 1) return options[0];
   else if (data === 2) return options[1];
   else return options[2];
};

export const checkIconSelect = (data) => {
   const options = [
      // { label: 'All', value: 0 },
      { label: 'Beauty & Health', value: 1 },
      { label: 'Entertainment', value: 2 },
      { label: 'Food & Beverage', value: 3 },
      { label: 'Free', value: 4 },
      { label: 'Hotel & Travel', value: 5 },
      { label: 'Housewares & Electronic', value: 6 },
      { label: 'Limited Edition', value: 7 },
      { label: 'New Arrival', value: 8 },
      { label: 'Bank', value: 9 },
      { label: 'Service', value: 10 },
      { label: 'Sport & Activity', value: 11 },
      { label: 'Survey', value: 12 },
   ];
   return options[data - 1];
};

export const checkCodeDivision = ({ department, district, branch }) => {
   if (department && department.length > 0) {
      if (district && district.length > 0) {
         if (branch && branch.length > 0) {
            return branch.map((obj) => obj.value.shortCode);
         } else {
            return district.map((obj) => obj.value.shortCode);
         }
      } else {
         return department.map((obj) => obj.value.shortCode);
      }
   } else {
      return ['10000000'];
   }
};

export const resolveDate = (date) => {
   let [d, m, y] = date.split('/');
   return `${d}/${m}/${+y + 543}`;
};
